import React, { lazy } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ourwork from "../../assets/ourwork.svg";
import Fade from 'react-reveal/Fade';


const OurWork = () => {
    const ContactSection = styled.section`
        width: 100vw;
        padding: calc(2.5rem + 2.5vw) 0;
        /* background-color: #0a0b10; */
        background-color: #808080;
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
        justify-content: center;
    `;
    const Title = styled.h1`
        color: #0a0b10;
        display: inline-block;
        font-size: calc(1rem + 1.5vw);
        margin-top: 1.5rem;
        position: relative;
        &::before {
            content: "";
            height: 1px;
            width: 50%;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translate(-50%, 0.5rem);
            /* or 100px */
            border-bottom: 2px solid var(--purple);
        }
        `;
    return ( <ContactSection id="ourWork1">
                <Fade top><Title>Our Work</Title></Fade>
                <Row className="ourWorkPadding">
                    <Col className=""><Fade left><center><img src={ourwork} alt="ourWork" className="weSupportImgDiv"/></center></Fade></Col>
                    <Col>
                        <div>
                            <Fade top>
                                <p className="ourWorkContent">
                                    <b className="ourWorkp">SAVyTech</b> 
                                     is the partner of choice for many of the enterprises. We help businesses elevate their value through our products which has applications spread across various sectors.

                                    We can help you transform your I.T infrastructure by making use of smarter and intelligent technology solutions.
                                </p>
                            </Fade>
                        </div>
                        <div>
                            <div>
                                <h2 className="weSupport">We develop</h2>
                            </div>
                            <div>
                                <ul className="weSupportList">
                                <Fade left><li>Web application</li></Fade>  
                                <Fade left><li>Mobile application</li></Fade>    
                                <Fade left><li>Desktop application</li></Fade>
                                <Fade left><li>Application testing tools</li></Fade>    
                                </ul>                
                            </div>
                            {/* <div>
                                <a href="/ourWorkdetails" className="moreAbtWrkatag">
                                    <label className="curPoint">Explore our more ...</label>
                                </a>
                            </div> */}
                        </div>
                    </Col>
                </Row>
            </ContactSection>);
};

export default OurWork;